import type { GoalSortEnum } from './components/__generated__/DirectoryViewGoalQuery.graphql';

export const DEFAULT_GOAL_SORTS: GoalSortEnum[] = ['WATCHING_DESC', 'LATEST_UPDATE_DATE_DESC', 'NAME_ASC'];
export const DEFAULT_TIMELINE_GOAL_SORTS: GoalSortEnum[] = ['START_DATE_ASC', 'NAME_ASC'];
